import {DecimalPipe} from '@angular/common'
import {Component, computed, inject} from '@angular/core'
import {BorgoService} from '../../../services/borgo.service'
import {KalpService} from '../../../services/kalp.service'

@Component({
  selector: 'spb-new-home-help',
  templateUrl: './new-home-help.component.html',
  styleUrls: ['../help.scss'],
  imports: [DecimalPipe]
})
export class NewHomeHelpComponent {

  public borgoService = inject(BorgoService)

  private readonly kalpService = inject(KalpService)

  public villa = computed(() => this.kalpService.getRunCost(this.borgoService.domain()))
  public bostadsratt = computed(() => this.kalpService.getRunCost(this.borgoService.domain(), 'BOSTADSRATT'))
  public fritidshus = computed(() => this.kalpService.getRunCost(this.borgoService.domain(), 'FRITIDSHUS'))
  public hyresratt = computed(() => this.kalpService.getRunCost(this.borgoService.domain(), 'HYRES'))
  public fastighetsAvgift = computed(() => this.kalpService.getYearlyTax(this.borgoService.domain()))
}
